import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Index from "./pages/Index"
import PackageDetails from "./pages/PackageDetails"
import Packages from "./pages/Packages"
import Support from "./pages/Support"
import Agency from "./pages/Agency"
import Book from "./pages/Book"
import Calculator from "./pages/Calculator"
import Challenge from "./pages/Challenge"
import Offer from "./pages/Offer"
import Login from "./pages/admin/Login"
import Setup from "./pages/admin/Setup"
import Dashboard from "./pages/admin/Dashboard"
import Quotes from "./pages/admin/Quotes"
import Offers from "./pages/admin/Offers"
import NotFound from "./pages/NotFound"
import OnePagerDirectory from "./pages/one-pagers/Directory"
import OnePagerDetail from "./pages/one-pagers/Detail"
import PdfExport from "./pages/one-pagers/PdfExport"
import { ModalProvider } from "@/components/modals/modal-provider"

const queryClient = new QueryClient()

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ModalProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/package-details" element={<PackageDetails />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/support" element={<Support />} />
            <Route path="/agency" element={<Agency />} />
            <Route path="/book" element={<Book />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/challenge" element={<Challenge />} />
            <Route path="/offer/:id" element={<Offer />} />
            <Route path="/one-pagers" element={<OnePagerDirectory />} />
            <Route path="/one-pagers/:slug" element={<OnePagerDetail />} />
            <Route path="/one-pagers/:slug/pdf" element={<PdfExport />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/setup" element={<Setup />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/quotes" element={<Quotes />} />
            <Route path="/admin/offers" element={<Offers />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ModalProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
)

export default App
